import a1 from "../assets/figma-garage/android-active-off-eye.svg"
import a2 from "../assets/figma-garage/android-active-off-journal.svg"
import a3 from "../assets/figma-garage/android-active-off-chevron.svg"
import a4 from "../assets/figma-garage/android-active-off-status.svg"
import a5 from "../assets/figma-garage/android-active-off-autoclan.svg"
import a6 from "../assets/figma-garage/android-active-off-privacy.svg"
import a7 from "../assets/figma-garage/android-active-off-clean-start.svg"
import a8 from "../assets/figma-garage/android-active-off-autotrade.svg"
import a9 from "../assets/figma-garage/android-active-off-insurance.svg"
import a10 from "../assets/figma-garage/android-active-off-pitstop.svg"
import a11 from "../assets/figma-garage/android-active-off-autohelp.svg"
import a12 from "../assets/figma-garage/android-active-off-companion.svg"
import a13 from "../assets/figma-garage/android-active-off-bb-help.svg"
import a15 from "../assets/figma-garage/android-active-on-eye.svg"
import a16 from "../assets/figma-garage/android-active-on-journal.svg"
import a17 from "../assets/figma-garage/android-active-on-chevron.svg"
import a18 from "../assets/figma-garage/android-active-on-status.svg"
import a19 from "../assets/figma-garage/android-active-on-autoclan.svg"
import a20 from "../assets/figma-garage/android-active-on-privacy.svg"
import a21 from "../assets/figma-garage/android-active-on-clean-start.svg"
import a22 from "../assets/figma-garage/android-active-on-autotrade.svg"
import a23 from "../assets/figma-garage/android-active-on-insurance.svg"
import a24 from "../assets/figma-garage/android-active-on-pitstop.svg"
import a25 from "../assets/figma-garage/android-active-on-autohelp.svg"
import a26 from "../assets/figma-garage/android-active-on-companion.svg"
import a27 from "../assets/figma-garage/android-active-on-bb-help.svg"
import a29 from "../assets/figma-garage/android-inactive-eye.svg"
import a30 from "../assets/figma-garage/android-inactive-journal.svg"
import a31 from "../assets/figma-garage/android-inactive-chevron.svg"
import a32 from "../assets/figma-garage/android-inactive-status.svg"
import a33 from "../assets/figma-garage/android-inactive-autoclan.svg"
import a34 from "../assets/figma-garage/android-inactive-privacy.svg"
import a35 from "../assets/figma-garage/android-inactive-clean-start.svg"
import a36 from "../assets/figma-garage/android-inactive-autotrade.svg"
import a37 from "../assets/figma-garage/android-inactive-insurance.svg"
import a38 from "../assets/figma-garage/android-inactive-pitstop.svg"
import a39 from "../assets/figma-garage/android-inactive-autohelp.svg"
import a40 from "../assets/figma-garage/android-inactive-companion.svg"
import a41 from "../assets/figma-garage/android-inactive-bb-help.svg"
import a43 from "../assets/figma-garage/ios-active-off-eye.svg"
import a44 from "../assets/figma-garage/ios-active-off-journal.svg"
import a45 from "../assets/figma-garage/ios-active-off-chevron.svg"
import a46 from "../assets/figma-garage/ios-active-off-status.svg"
import a47 from "../assets/figma-garage/ios-active-off-autoclan.svg"
import a48 from "../assets/figma-garage/ios-active-off-privacy.svg"
import a49 from "../assets/figma-garage/ios-active-off-clean-start.svg"
import a50 from "../assets/figma-garage/ios-active-off-autotrade.svg"
import a51 from "../assets/figma-garage/ios-active-off-insurance.svg"
import a52 from "../assets/figma-garage/ios-active-off-pitstop.svg"
import a53 from "../assets/figma-garage/ios-active-off-autohelp.svg"
import a54 from "../assets/figma-garage/ios-active-off-companion.svg"
import a55 from "../assets/figma-garage/ios-active-off-bb-help.svg"
import a57 from "../assets/figma-garage/ios-active-on-eye.svg"
import a58 from "../assets/figma-garage/ios-active-on-journal.svg"
import a59 from "../assets/figma-garage/ios-active-on-chevron.svg"
import a60 from "../assets/figma-garage/ios-active-on-status.svg"
import a61 from "../assets/figma-garage/ios-active-on-autoclan.svg"
import a62 from "../assets/figma-garage/ios-active-on-privacy.svg"
import a63 from "../assets/figma-garage/ios-active-on-clean-start.svg"
import a64 from "../assets/figma-garage/ios-active-on-autotrade.svg"
import a65 from "../assets/figma-garage/ios-active-on-insurance.svg"
import a66 from "../assets/figma-garage/ios-active-on-pitstop.svg"
import a67 from "../assets/figma-garage/ios-active-on-autohelp.svg"
import a68 from "../assets/figma-garage/ios-active-on-companion.svg"
import a69 from "../assets/figma-garage/ios-active-on-bb-help.svg"
import a71 from "../assets/figma-garage/ios-inactive-eye.svg"
import a72 from "../assets/figma-garage/ios-inactive-journal.svg"
import a73 from "../assets/figma-garage/ios-inactive-chevron.svg"
import a74 from "../assets/figma-garage/ios-inactive-status.svg"
import a75 from "../assets/figma-garage/ios-inactive-autoclan.svg"
import a76 from "../assets/figma-garage/ios-inactive-privacy.svg"
import a77 from "../assets/figma-garage/ios-inactive-clean-start.svg"
import a78 from "../assets/figma-garage/ios-inactive-autotrade.svg"
import a79 from "../assets/figma-garage/ios-inactive-insurance.svg"
import a80 from "../assets/figma-garage/ios-inactive-pitstop.svg"
import a81 from "../assets/figma-garage/ios-inactive-autohelp.svg"
import a82 from "../assets/figma-garage/ios-inactive-companion.svg"
import a83 from "../assets/figma-garage/ios-inactive-bb-help.svg"
import androidActivationNote from "../assets/figma-garage/android-activation-note.svg"
import iosActivationNote from "../assets/figma-garage/ios-activation-note.svg"
import inactiveLock from "../assets/figma-garage/inactive-lock.svg"

type Platform = "android" | "ios"
type State = "inactive" | "active-off" | "active-on"

const assets: Record<string, string> = {
  "android/active-off/eye": a1,
  "android/active-off/journal": a2,
  "android/active-off/chevron": a3,
  "android/active-off/status": a4,
  "android/active-off/autoclan": a5,
  "android/active-off/privacy": a6,
  "android/active-off/clean-start": a7,
  "android/active-off/autotrade": a8,
  "android/active-off/insurance": a9,
  "android/active-off/pitstop": a10,
  "android/active-off/autohelp": a11,
  "android/active-off/companion": a12,
  "android/active-off/bb-help": a13,
  "android/active-on/eye": a15,
  "android/active-on/journal": a16,
  "android/active-on/chevron": a17,
  "android/active-on/status": a18,
  "android/active-on/autoclan": a19,
  "android/active-on/privacy": a20,
  "android/active-on/clean-start": a21,
  "android/active-on/autotrade": a22,
  "android/active-on/insurance": a23,
  "android/active-on/pitstop": a24,
  "android/active-on/autohelp": a25,
  "android/active-on/companion": a26,
  "android/active-on/bb-help": a27,
  "android/inactive/eye": a29,
  "android/inactive/journal": a30,
  "android/inactive/chevron": a31,
  "android/inactive/status": a32,
  "android/inactive/autoclan": a33,
  "android/inactive/privacy": a34,
  "android/inactive/clean-start": a35,
  "android/inactive/autotrade": a36,
  "android/inactive/insurance": a37,
  "android/inactive/pitstop": a38,
  "android/inactive/autohelp": a39,
  "android/inactive/companion": a40,
  "android/inactive/bb-help": a41,
  "ios/active-off/eye": a43,
  "ios/active-off/journal": a44,
  "ios/active-off/chevron": a45,
  "ios/active-off/status": a46,
  "ios/active-off/autoclan": a47,
  "ios/active-off/privacy": a48,
  "ios/active-off/clean-start": a49,
  "ios/active-off/autotrade": a50,
  "ios/active-off/insurance": a51,
  "ios/active-off/pitstop": a52,
  "ios/active-off/autohelp": a53,
  "ios/active-off/companion": a54,
  "ios/active-off/bb-help": a55,
  "ios/active-on/eye": a57,
  "ios/active-on/journal": a58,
  "ios/active-on/chevron": a59,
  "ios/active-on/status": a60,
  "ios/active-on/autoclan": a61,
  "ios/active-on/privacy": a62,
  "ios/active-on/clean-start": a63,
  "ios/active-on/autotrade": a64,
  "ios/active-on/insurance": a65,
  "ios/active-on/pitstop": a66,
  "ios/active-on/autohelp": a67,
  "ios/active-on/companion": a68,
  "ios/active-on/bb-help": a69,
  "ios/inactive/eye": a71,
  "ios/inactive/journal": a72,
  "ios/inactive/chevron": a73,
  "ios/inactive/status": a74,
  "ios/inactive/autoclan": a75,
  "ios/inactive/privacy": a76,
  "ios/inactive/clean-start": a77,
  "ios/inactive/autotrade": a78,
  "ios/inactive/insurance": a79,
  "ios/inactive/pitstop": a80,
  "ios/inactive/autohelp": a81,
  "ios/inactive/companion": a82,
  "ios/inactive/bb-help": a83,
}

export function garageAsset(platform: Platform, state: State, key: string): string {
  return assets[`${platform}/${state}/${key}`]
}

export function garageActivationNote(platform: Platform): string {
  return platform === "ios" ? iosActivationNote : androidActivationNote
}

export const garageInactiveLock = inactiveLock
